import { IExternalId } from '../../../../typings/IPrebid'
import { AgentType } from '../../../enums/AgentType'

export function getEIDs(mv_uuid?: string): Array<IExternalId> {
  const eids = window.pbjs.getUserIdsAsEids() || []
  const userIds = window.pbjs.getUserIds() || []

  if (window.$mediavine.uid2) {
    eids.unshift(buildUID2(window.$mediavine.uid2))
  }

  // override pubcommon id with mv_uuid
  for (const eid of eids) {
    if (mv_uuid && eid.source === 'pubcid.org' && eid.uids?.length) {
      eid.uids[0].id = mv_uuid
    }

    if (
      window.$mediavine.id5Id &&
      eid.source === 'id5-sync.com' &&
      eid.uids.length
    ) {
      eid.uids[0].id = window.$mediavine.id5Id
      eid.uids[0].ext = {
        linkType: 2
      }
    }
  }

  // tack on FLoC id in eids.  Later, Prebid intends to add a function called getUserIdsAsEidsWithFloc().
  if (userIds.flocId) {
    eids.push({
      source: 'chrome.com',
      uids: [
        {
          id: userIds.flocId.id,
          atype: 1,
          ext: {
            ver: userIds.flocId.version
          }
        }
      ]
    })
  }

  return eids
}

function buildUID2(id): IExternalId {
  return {
    source: 'uidapi.com',
    uids: [
      {
        id,
        atype: AgentType.personBased,
        ext: {
          rtiPartner: 'UID2'
        }
      }
    ]
  }
}
